import React from 'react'
import Reflux from 'reflux'
import Store from '../../../store/store'
import i18 from '../../../i18'
import api from '../../../source/api'
import NotificationSystem from 'react-notification-system'
import ListRowUnprocessed from "./assignment/ListRowUnprocessed";
import ListRowUnprocessedInvoiceRule from "./assignment/ListRowUnprocessedInvoiceRule";
import ListRowProcessed from "./assignment/ListRowProcessed";

class Assignment extends Reflux.Component {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            processing: false,
            showProcessedItems: false,
            processedCount: 0,
            company: props.company,
            userconfigs: props.userconfigs,
            vatCollectorCodes: props.vatCollectorCodes,
            invoices: props.invoices,
            customerRules: props.customerRules,
        }
        this.store = Store
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem
        window.scrollTo(0, 0)
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            vatCollectorCodes: nextProps.vatCollectorCodes,
            invoices: nextProps.invoices,
            customerRules: nextProps.customerRules,
            company: nextProps.company,
            userconfigs: nextProps.userconfigs,
        });
    }

    _addNotification = (msg, type, time = 30) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    startProcessing = () => {
        this.props.nextStep()
    }

    createRule = (rule) => {
        api.post({url: 'customer/rule/add?company_id=' + this.state.company.id, data: rule}, true)
            .then((response) => {

                this._addNotification('Szabály sikeresen mentve.', 'success', 10)

                let rulesCount = this.props.updateInvoices(this.state.invoices, response.data.customerRules);
                if (rulesCount.addRuleCount > 0) {
                    this._addNotification(rulesCount.addRuleCount + ' db. sor sikeresen kontírozva.', 'success', 10);
                }
            })
    }

    showHideProcessedItems = () => {
        this.setState({showProcessedItems: !this.state.showProcessedItems})
    }

    hasUnprocessedInvoice = () => {
        for (let index in this.state.invoices) {
            let invoice = this.state.invoices[index]
            for (let itemIndex in invoice.items) {
                let invoiceItem = invoice.items[itemIndex];
                if (!invoiceItem.rule_id) {
                    return true;
                }
            }
        }
        return false;
    }

    listInvoices = () => {
        let invoices = [];

        for (let index in this.state.invoices) {
            let invoice = this.state.invoices[index]
            for (let itemIndex in invoice.items) {
                let invoiceItem = invoice.items[itemIndex];

                if (invoiceItem.rule_id) {
                    continue;
                }

                let key = index + '-' + itemIndex + '-' + Math.random(9999, 99999);
                invoices.push(
                    this.state.userconfigs.invoice_number_rule === 'ENABLED'
                        ? <ListRowUnprocessedInvoiceRule
                            key={key}
                            invoice={invoice}
                            invoiceItem={invoiceItem}
                            vatCollectorCodes={this.state.vatCollectorCodes}
                            company={this.state.company}
                            _addNotification={(msg, type, time) => this._addNotification(msg, type, time)}
                            createRule={(rule) => this.createRule(rule)}
                        />
                        : <ListRowUnprocessed
                            key={key}
                            invoice={invoice}
                            invoiceItem={invoiceItem}
                            vatCollectorCodes={this.state.vatCollectorCodes}
                            company={this.state.company}
                            _addNotification={(msg, type, time) => this._addNotification(msg, type, time)}
                            createRule={(rule) => this.createRule(rule)}
                        />
                );
            }
        }

        return invoices
    }

    listProcessedInvoices = () => {
        let invoices = [];

        for (let index in this.state.invoices) {
            let invoice = this.state.invoices[index]
            for (let itemIndex in invoice.items) {
                let invoiceItem = invoice.items[itemIndex];

                if (!invoiceItem.rule_id) {
                    continue;
                }

                let rule = this.state.customerRules.find(x => x.id === invoiceItem.rule_id);
                let key = index + '-' + itemIndex + '-' + Math.random(9999, 99999);

                invoices.push(
                    <ListRowProcessed
                        key={key}
                        invoice={invoice}
                        invoiceItem={invoiceItem}
                        rule={rule}
                        company={this.state.company}
                        _addNotification={(msg, type, time) => this._addNotification(msg, type, time)}
                    />
                );

            }
        }

        return invoices
    }

    render = () => {
        return (
            <section id='customer-assignment' className='margin-bottom-50'>

                <div className='row'>
                    <div className='col-md-6'>
                        <ul className='legend'>
                            <li><i className='fa fa-dot-circle-o' aria-hidden='true'/> <span className=''>{i18.CUSTOMER._createRulesAndProcess}</span></li>
                            <li><i className='padding-left-20 fa fa-check-circle' aria-hidden='true'/> <span className=''>{i18.CUSTOMER._oneTimeProcessing}</span></li>
                        </ul>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <p>Szabályok súlyozásához a szabály elé kell írni '#' jelet és egy számot. Pl: "#3Előleg levonása", "#8Előleg".</p>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <table className='table table-striped  table-aibook-no-border'>
                            <thead>
                            <tr>
                                <th>{i18.CUSTOMER._typeOfTraffic}</th>
                                <th>{i18.CUSTOMER._mainBookNumber}</th>
                                <th>{i18.CUSTOMER._VAT}</th>
                                <th>{i18.CUSTOMER._collectorCode}</th>
                                <th>{i18.CUSTOMER._taxNumber}</th>
                                <th>{i18.CUSTOMER._city}</th>
                                <th>{i18.CUSTOMER._companyName}</th>
                                <th>{i18.CUSTOMER._paymentType}</th>
                                <th>{i18.CUSTOMER._voucher_nb}</th>
                                <th>{i18.CUSTOMER._vatDegreeNumber}</th>
                                <th>&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.listInvoices()}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='row margin-bottom-50'>
                    <div className='col-12'>
                        <div className='next-step-btn-container'>
                            <a onClick={() => this.startProcessing()} className={this.state.processing ? 'disabled next-step pull-right' : 'next-step pull-right'}>Feldolgozás</a>
                            <a onClick={() => this.showHideProcessedItems()} className='next-step pull-left'>Feldolgozott tételek</a>
                        </div>
                    </div>
                </div>
                <div className={this.state.showProcessedItems ? '' : 'd-none'}>
                    <table className='table table-striped  table-aibook-no-border'>
                        <thead>
                        <tr>
                            <th>{i18.CUSTOMER._typeOfTraffic}</th>
                            <th>{i18.CUSTOMER._mainBookNumber}</th>
                            <th>{i18.CUSTOMER._VAT}</th>
                            <th>{i18.CUSTOMER._collectorCode}</th>
                            <th>{i18.CUSTOMER._taxNumber}</th>
                            <th>{i18.CUSTOMER._city}</th>
                            <th>{i18.CUSTOMER._companyName}</th>
                            <th>{i18.CUSTOMER._paymentType}</th>
                            <th>{i18.CUSTOMER._voucher_nb}</th>
                            <th>{i18.CUSTOMER._vatDegreeNumber}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.listProcessedInvoices()}
                        </tbody>
                    </table>
                </div>
                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default Assignment


// WEBPACK FOOTER //
// ./src/components/customer/steps/assignment.js